import { render, staticRenderFns } from "./productCenNav.vue?vue&type=template&id=18d9edfc&scoped=true&"
import script from "./productCenNav.vue?vue&type=script&lang=js&"
export * from "./productCenNav.vue?vue&type=script&lang=js&"
import style1 from "./productCenNav.vue?vue&type=style&index=1&id=18d9edfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d9edfc",
  null
  
)

export default component.exports